import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Button,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
} from '@mui/material';
import './AddAsset1.css';
import { SaveAlt as SaveAltIcon } from '@mui/icons-material';
import { Country, City } from 'country-state-city';
import {Row,Col} from 'react-bootstrap';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function AddAsset1({handlePrevious,handleNext,order}) {
  const theme = useTheme();
  const [boatType, setBoatType] = React.useState('Power');
  const [country, setCountry] = React.useState('Afghanistan');
  const [countries, setCountries] = React.useState([]);
  const [cities, setCities] = React.useState([]);
  const [preDefinedCities, setPreDefinedCities] = React.useState(['Karachi']);

  React.useEffect(() => {
    setCountries(Country.getAllCountries());

    // https://github.com/harpreetkhalsagtbit/country-state-city
    // https://npm.io/package/country-state-city
  }, []);

  React.useEffect(() => {
    // if (country) setPreDefinedCities(City.getCitiesOfCountry(country.isoCode));
  }, [country]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setCities(typeof value === 'string' ? value.split(',') : value);
  };

  return (
    <div className='addAsset1_Main'>
      <Row>
        <Col sm={6}>
        <input className='make addAsset1_Input' placeholder='Make' />
        </Col>
        <Col sm={6}>
        <input className='mode addAsset1_Input' placeholder='Model' />
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
        <input className='Length addAsset1_Input' placeholder='Length' />
        </Col>
        <Col sm={6}>
        <input className='year addAsset1_Input' placeholder='Year' />
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
        <input className='Name addAsset1_Input' placeholder='Name' />
        </Col>
        <Col sm={6}>
        <input className='booking addAsset1_Input' placeholder='Booking Number' />
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
        <input className='Pick_Up addAsset1_Input' placeholder='Pick Up Point' />
        </Col>
        <Col sm={6}>
        <input className='Drop_off addAsset1_Input' placeholder='Drop Off Point' />
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
        <select
         className='type addAsset1_Input'>
          <option>Power</option>
          <option>Sail</option>
        </select>
        </Col>
        <Col sm={6}>

        <select
         className='countries addAsset1_Input'>
         {countries.map((element, key) => (
            <option key={key} value={element}>
              {element.name}
            </option>
          ))}
        </select>
        </Col>
      </Row>

      <Row>
        <Col sm={6}>

      {country && (
        <>
            <select
             className='cities addAsset1_Input'
              value={cities}
              onChange={handleChange}
              >
              {preDefinedCities.map((element, key) => (
                <option
                  key={key}
                  value={element}>
                  {element}
                </option>
              ))}
            </select>
        </>
      )}
        </Col>

        <Col>
        </Col>
      </Row>

      <div className='chngBtnDiv' >
      <button
        className='prevBtn'
        onClick={handlePrevious}
        disabled={order === 0}
        >
        Prev
      </button>
      <button
        className='nextBtn'
        disabled={order === 3}
        onClick={handleNext}
        >
        Next
      </button>
      </div>
      <br />

    </div>
  );
}
